import React from 'react'

export default function HomeTeam() {
  return (
    <>
    <section className="hometeam">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-6 col-sm-8 col-md-7">
                    <h4 className="heading center-heading">Meet the Minds behind The design</h4>
                </div>

            </div>
        </div>
    </section>

    <section className="hometeam-detail">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-4 col-sm-6 col-md-5">
                    <div className="hometeam-box wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.1s">
                        <picture>
                            <img src="/assets/images/team-1.webp" className="img-responsive" alt="team" loading="lazy"/>
                            <a href="https://www.linkedin.com/in/parul-agarwal-a9863312a/" target="_blank" aria-label="linkedin" rel="noreferrer"><i className="fa-brands fa-linkedin-in"></i> </a>
                        </picture>

                        <a href="https://www.linkedin.com/in/parul-agarwal-a9863312a/" target="_blank" aria-label="linkedin" rel="noreferrer">
                            <div>
                                <label>Parul Agarwal</label>
                                <p>Co-Founder, HOD Design & Projects</p>
                            </div>
                        </a>
                    </div>
                </div>

                <div className="col-lg-4 col-sm-6 col-md-5">
                    <div className="hometeam-box teambox-2 wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.2s">
                        <picture>
                            <img src="/assets/images/team-2.webp" className="img-responsive" alt="team" loading="lazy"/>
                            <a href="https://www.linkedin.com/in/vineet-agarwal-307a70/" target="_blank" aria-label="linkedin" rel="noreferrer"><i className="fa-brands fa-linkedin-in"></i> </a>
                        </picture>
                        
                        <a href="https://www.linkedin.com/in/vineet-agarwal-307a70/" target="_blank" aria-label="linkedin" rel="noreferrer">
                            <div>
                                <label>Vineet Agarwal</label>
                                <p>Co-Founder, HOD Growth & Strategy</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section> 
    </>
  )
}
